import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { formatDecimal } from '@bingads-webui-campaign/recommendation-core';
import template from './number-column.pug';

export class NumberImpressionsColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, recommendationType }) {
    super({
      name: 'NumImpressions',
      property: 'NumImpressions',
      title: i18n.getString('Recommendation_ColumnName_PreviousImpression'),
      bodyClasses: ['grid-column-numberImpressions'],
      colClasses: ['col-longText'],
      sortable: 'Microsoft.Advertiser.AdInsight.Opportunity.Schema.SetupConversionTrackingOpportunitySummary/NumImpressions',
      type: 'number',
    });
    this.i18n = i18n;
    this.recommendationType = recommendationType;
  }

  template({
    value: {
      NumImpressions,
    },
  }) {
    const { i18n } = this;

    return template({
      number: formatDecimal(NumImpressions, i18n),
      i18n,
    });
  }

  get property() {
    return {
      get: _.identity,
      key: 'NumImpressions',
    };
  }
}
